<template>
  <div>
    <el-row class="content-row"
      v-if="trackType === '01' && info.incentiveFee"
    >
      <el-col :span="3">单张拍照打卡激励/周</el-col>
      <el-col :span="9">{{ info.incentiveFee || "" }}元</el-col>
    </el-row>

    <el-row class="content-row">
      <el-col :span="3">执行类型</el-col>
      <el-col :span="9">{{ scopeDefineTypeName }}</el-col>
    </el-row>

    <!-- 组合陈列 -->
    <div v-if="info.scopeDefineType === '04'">
      <el-row class="content-row">
        <el-col :span="3">组合陈列套餐</el-col>
        <el-col :span="21">
          <div>{{ info.mixinDisplayName }}</div>
          <div class="detail-item">
            <div class="detail-item-name" v-if="info.stackVersion !== '6.0'">
              <div v-if="info.stackBrandCode !== 'BUDHD'">堆箱：</div>
              <div v-else>混堆：</div>
            </div>
            <div class="detail-item-name" v-else>
              <div>堆箱</div>
            </div>
            <div class="detail-item-list"
              v-if="info.stackBrandCode !== 'BUDHD' && info.stackVersion !== '6.0'"
            >
              {{ info.brandName }}-
              {{ info.subBrandName }}-
              {{ info.stackSize }}
            </div>
            <div v-if="info.stackBrandCode === 'BUDHD' && info.stackVersion !== '6.0'">
              混堆-{{ info.stackSize }}
            </div>
            <div v-if="info.stackVersion === '6.0'">
              堆箱-{{ info.stackSize }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item-name">产品：</div>
            <div class="detail-item-list">
              <div v-for="(list, index) in info.displayDetailList" :key="index">
                {{ list.brandName || list.brandDTO.abiBrandDesc }}-
                {{ list.subBrandName || list.subBrandDTO.abiBrandDesc }}-
                {{ list.volume }}-
                {{ list.multiPackSpec }}-
                {{ list.minDisplayQty }}件-
                {{ list.rowQty }}面
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 堆箱任务 -->
    <div v-if="info.perfectTaskType === '01' && info.scopeDefineType !== '04'">
      <!-- <el-row class="content-row" v-if="info.stackVersion !== '6.0'">
        <el-col :span="3">堆箱品牌</el-col>
        <el-col :span="9">
          {{ info.stackBrandName || info.brandName }}
        </el-col>
        <el-col :span="3">堆箱子品牌</el-col>
        <el-col :span="9">
          {{ info.stackSubBrandName || info.subBrandName }}
        </el-col>
      </el-row> -->
      <el-row class="content-row">
        <el-col :span="3">堆箱名称</el-col>
        <el-col :span="9">{{ info.mixinPackName }}</el-col>
        <el-col :span="3">堆箱规格</el-col>
        <el-col :span="9">{{ info.stackSize }}</el-col>
      </el-row>
    </div>
    <el-row class="content-row"
      v-if="info.perfectTaskType === '01' || info.scopeDefineType === '04'"
    >
        <el-col :span="24">堆箱排列图</el-col>
        <el-col :span="24" class="stack-wrapper">
          <div
            class="design-column"
            v-for="(item, index) in columnList"
            :key="index"
          >
            <div class="design-row" v-for="(temp, idx) in rowList" :key="idx">
              <div class="design-box" :style="{ background: temp.color }">
                <div class="text" v-if="!index">{{ temp.brandName }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

    <!-- 货架任务/冰柜任务 -->
    <div v-if="info.perfectTaskType !== '01' && info.scopeDefineType !== '04'">
      <el-row class="content-row">
        <el-col :span="3">必备品/排面数</el-col>
        <el-col :span="21">
          <div>{{ info.mandatoryItemName }}</div>
          <div
            v-for="(item, index) in info.mandatoryDetailList"
            :key="index"
            class="detail-row-mandatory"
          >
            {{ item.brandName || item.brandDTO.abiBrandName }}-
            {{ item.subBrandName || item.subBrandDTO.abiBrandName }}-
            {{ item.volume }}-
            {{ item.multiPackSpec || '1*1' }}-
            {{ item.minDisplayQty }}件-
            {{ item.multiPackSpec ? item.rowQty : item.minDisplayQty }}面
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row class="content-row">
      <el-col :span="3">{{ info.perfectTaskTypeName }}标准照片</el-col>
      <el-col :span="9" v-viewer="{ movable: true }" class="info-img">
        <img :src="getImg(info.checkPhotoUri)" />
        <div class="img-check-result">
          {{ getImgStatus(info.checkResult) }}
        </div>
        <div v-if="!!info.errorList">
          <div class="result-detail" style="color:red">验证未通过原因</div>
          <div class="img-check-result result-detail" v-for="(item, index) in info.errorList" :key="index">
            <div>· {{ item }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="3" v-if="info.bonusFee !== null">陈列费/周</el-col>
      <el-col :span="9" v-if="info.bonusFee !== null">{{ info.bonusFee }}元</el-col>
      <el-col :span="3" v-if="info.bonusBeer !== null">每周赠酒箱数</el-col>
      <el-col :span="9" v-if="info.bonusBeer !== null">{{ info.bonusBeer }}箱</el-col>
    </el-row>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'perfect-task-info',
  props: {
    info: {
      type: Object,
      default: null
    },
    trackType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      columnList: [],
      rowList: []
      // errorList: ['百威 百威不足2个', '百威 百威不足2个']
    }
  },
  computed: {
    scopeDefineTypeName () {
      if (!this.info) return
      if (this.info.scopeDefineType !== '01' || this.info.stackVersion === '6.0') {
        return this.info.scopeDefineTypeName
      } else {
        return this.info.stackBrandCode === 'BUDHD' ? '堆箱-混堆' : '堆箱-单堆'
      }
    }
  },
  created () {},
  methods: {
    setDesignInfo () {
      if (this.info.stackDesignColorList) {
        const designSize = this.info.stackSize.split('*')
        this.columnList = new Array(Number(designSize[0])).fill('')
        this.rowList = new Array(Number(designSize[1])).fill('')
        if (this.info.stackDesignColorList.length === 1) {
          for (let i = 0; i < this.rowList.length; i++) {
            this.rowList[i] = this.info.stackDesignColorList[0]
          }
        } else {
          for (let i = 0; i < this.rowList.length; i++) {
            this.rowList[i] = this.info.stackDesignColorList[i]
          }
        }
      }
    },

    getImgStatus (val) {
      const resultObj = {
        // eslint-disable-next-line quote-props
        '0': '(验证未通过)',
        // eslint-disable-next-line quote-props
        '1': '(验证通过)',
        '-1': '(验证结果暂未返回)',
        '-2': '(待人工审核)'
      }
      return resultObj[String(val)]
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
.design-column {
  display: flex;
  align-items: center;
  justify-content: center;

  .design-box {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin: 1px;
    padding: 0 2px;
    text-align: center;
    box-sizing: border-box;

    .text {
      font-size: 12px;
      word-break: break-all;
      color: #fff;
    }
  }
}

.detail-row-mandatory {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.info-img {
  img {
    width: 170px;
    height: 110px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
}

.img-check-result {
  width: 170px;
  text-align: center;
  color: #666;
  font-size: 12px;
}
.result-detail {
  padding-top: 10px;
  text-align: left;
  font-size: 12px;
}

.detail-item {
  display: flex;
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  &>div {
    flex-shrink: 0;
  }
  .detail-item-name {
    width: 80px;
  }
  .detail-item-list {
    width: calc(100% - 80px);
    &>div {
      margin-bottom: 5px;
    }
  }
}
</style>
